import {
  withCompInfo,
  createComponentMapperModel,
} from '@wix/editor-elements-integrations';

const props = withCompInfo<any, any>()(['compData'], ({ compData }) => {
  return {
    ...{
      showNumericInput: true,
      stepValue: 1,
      maximumValue: 100,
      minimumValue: 0,
      defaultSelectedValue: 0,
      unitOfMeasurement: 'number',
      tooltipInfo: '',
      fieldTitle: 'Slider',
    },
    ...compData,
  };
});

export default createComponentMapperModel({
  props,
});
